import React, { Component } from 'react';
import { selectors, actions } from '../sagas/sign_up/account_information';
import { actions as company_actions } from '../sagas/account';
import { selectors as company_selectors } from '../sagas/account';
import { TextInput } from '../shared/TextInput'
import { reduxForm } from 'redux-form'
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import KmDatePicker from '../shared/KmDatePicker'
import { FormError } from '../shared/FormError'
import moment from 'moment'

class CreateAccountForm extends Component {
  constructor(props) {
    super(props)
    this.createCompanyInfoForm = this.props.actions.accountActions.createCompanyInfoForm.bind(this)
    this.props.actions.accountActions.setUserId(this.props.userId)
  }

  handleCustomSubmit = () => {
    this.createCompanyInfoForm(this.props.user_form)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <div>
        <div className={'row'}>
          <div className={'column'}>
          </div>
          <div className={'double-column'}>
            { this.props.errors && Object.keys(this.props.errors).length > 0 && <FormError errors={this.props.errors}/> }
          </div>
          <div className={'column'}>
          </div>
        </div>
        <form
          onSubmit={handleSubmit(this.handleCustomSubmit)}>
          <div>
            <div className={'sign-up-layout row'}>
              <div className={'column'}>
              </div>
              <div className={'column'}>
                <TextInput
                  placeholderText={'Business Name'}
                  inputName={'name'}
                  label={'Business Name'}
                  errors={ this.props.errors }
                />
                <TextInput
                  placeholderText={'Email'}
                  inputName={'companyEmail'}
                  label={'Company Email'}
                  errors={ this.props.errors }
                />
                <TextInput
                  placeholderText={'( )'}
                  inputName={'phone'}
                  label={'Phone'}
                  errors={ this.props.errors }
                />
                <TextInput
                  placeholderText={'Website'}
                  inputName={'website'}
                  label={'Website'}
                  errors={ this.props.errors }
                />
              </div>
              <div className={'column'}>
                <TextInput
                  placeholderText={'Street Address'}
                  inputName={'streetAddress'}
                  label={'Street Address'}
                  errors={ this.props.errors }
                />
                <TextInput
                  placeholderText={'Apt/Suite'}
                  inputName={'address2'}
                  label={'Address Line 2'}
                  errors={ this.props.errors }
                />
                <TextInput
                  placeholderText={'City'}
                  inputName={'city'}
                  label={'City'}
                  errors={ this.props.errors }
                />
                <TextInput
                  placeholderText={'State/Province'}
                  inputName={'state'}
                  label={'State'}
                  errors={ this.props.errors }
                />
                <TextInput
                  placeholderText={'Postal Code'}
                  inputName={'postalCode'}
                  label={'Postal Code'}
                  errors={ this.props.errors }
                />
              </div>
              <div className={'column'}>
              </div>
            </div>
            <div className={'row'}>
              <div className={'column'}>
                &nbsp;
              </div>
              <div style={{ flex: 2 }} className={'double-column'}>
                <div className={'create-account-button'}>
                  <input
                    value="Create"
                    type="submit"
                    id='continue-button' />
                </div>
              </div>
              <div className={'column'}>
                &nbsp;
              </div>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  initialValues: company_selectors.account_info(store),
  birthdate: selectors.birthdate(store),
  errors: selectors.errors(store)
});

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      company_actions: bindActionCreators(company_actions, dispatch),
      accountActions: bindActionCreators(actions, dispatch)
    }
  };
}

export default (connect(
  mapStateToProps, mapDispatchToProps)(
  reduxForm(
  { form: 'account_form'}
)(CreateAccountForm)));



// WEBPACK FOOTER //
// ./src/Account/create_form.jsx